import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { FaUserShield } from "react-icons/fa";
import API_BASE_URL from "../../apiconfig";

function Login() {

	const navigate = useNavigate();

	const [mobile, setMobile] = useState("");
	const [securityKey, setSecurityKey] = useState("");
	const [showKey, setShowKey] = useState(false);

	const [alertData, setAlertData] = useState(null);

	const showAlert = (message, type = "error") => {
		setAlertData({
			message,
			type,
			id: Date.now()
		});

		setTimeout(() => {
			setAlertData(null);
		}, 4000);
	};

	const validateMobile = () => {

		const mobileRegex = /^[6-9]\d{9}$/;

		if (!mobile) {
			showAlert("Please enter mobile number ❗");
			return false;
		}

		if (!mobileRegex.test(mobile)) {
			showAlert("Enter valid 10-digit mobile number ❗");
			return false;
		}

		return true;
	};

	const validateKey = () => {

		if (!securityKey || securityKey.trim() === "") {
			showAlert("Please enter security key ❗");
			return false;
		}

		if (securityKey.length < 4) {
			showAlert("Security key is too short ❗");
			return false;
		}

		return true;
	};

	const handleLogin = async () => {

		if (!validateMobile()) return;
		if (!validateKey()) return;

		try {

			const response = await fetch(
				`${API_BASE_URL}/API/Admin/LOGIN`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json"
					},
					body: JSON.stringify({
						mobile: mobile,
						securityKey: securityKey
					})
				}
			);

			const data = await response.json();

			if (response.ok) {

				sessionStorage.setItem("adminToken", data.token);

				showAlert(
					data.message || "Admin Login Successful ✅",
					"success"
				);

				setTimeout(() => {
					navigate("/AdminDashboard");
				}, 1200);

			} else {

				showAlert(
					data.message || "Invalid Credentials ❌"
				);
			}

		} catch (error) {

			showAlert("Server Error ❌");
		}
	};

	return (
		<>
			<style>{`

				.main-section{
					display:flex;
					justify-content:center;
					align-items:center;
					padding:40px 15px;
					min-height:75vh;
					background:
					linear-gradient(
					135deg,
					#edf4ff,
					#f7fbff
					);

					font-family:'Poppins',sans-serif;
				}

				.card{
					width:100%;
					max-width:430px;
					background:white;
					border-radius:20px;
					padding:30px 25px;
					box-shadow:
					0 10px 30px rgba(0,0,0,0.08);

					border:1px solid rgba(0,0,0,0.05);

					animation:fadeUp .5s ease;
				}

				@keyframes fadeUp{
					from{
						opacity:0;
						transform:translateY(25px);
					}
					to{
						opacity:1;
						transform:translateY(0);
					}
				}

				.logo-section{
					text-align:center;
					margin-bottom:25px;
				}

				.logo-circle{
					width:85px;
					height:85px;
					border-radius:50%;
					background:
					linear-gradient(
					135deg,
					#0d47a1,
					#1976d2
					);

					display:flex;
					align-items:center;
					justify-content:center;
					margin:auto;
					box-shadow:
					0 8px 20px rgba(25,118,210,.3);
				}

				.logo-icon{
					font-size:38px;
					color:white;
				}

				.title{
					margin-top:15px;
					font-size:24px;
					font-weight:700;
					color:#0d47a1;
				}

				.subtitle{
					font-size:13px;
					color:#666;
					margin-top:4px;
				}

				.input-group{
					margin-bottom:18px;
				}

				.label{
					display:block;
					margin-bottom:7px;
					font-size:13px;
					font-weight:600;
					color:#333;
				}

				.input{
					width:100%;
					padding:13px 14px;
					border-radius:12px;
					border:1px solid #dcdcdc;
					font-size:14px;
					transition:.25s;
					box-sizing:border-box;
				}

				.input:focus{
					outline:none;
					border-color:#1976d2;
					box-shadow:
					0 0 0 3px rgba(25,118,210,.12);
				}

				.password-row{
					display:flex;
					align-items:center;
					gap:8px;
				}

				.eye-btn{
					border:none;
					background:#eef5ff;
					padding:11px 13px;
					border-radius:10px;
					cursor:pointer;
					font-size:16px;
					transition:.2s;
				}

				.eye-btn:hover{
					background:#dbe9ff;
				}

				.login-btn{
					width:100%;
					border:none;
					padding:13px;
					border-radius:14px;

					background:
					linear-gradient(
					135deg,
					#0d47a1,
					#1976d2
					);

					color:white;
					font-size:15px;
					font-weight:700;
					cursor:pointer;
					transition:.3s;
					margin-top:10px;
				}

				.login-btn:hover{
					transform:translateY(-2px);

					box-shadow:
					0 10px 20px rgba(25,118,210,.25);
				}

				.footer-text{
					text-align:center;
					margin-top:18px;
					font-size:12px;
					color:#888;
				}

				.custom-alert {
							position: fixed;
							top: 30%;
							left: 50%;
							transform: translateX(-50%);
							display: flex;
							align-items: center;
							gap: 10px;
							min-width: 260px;
							max-width: 320px;
							padding: 12px 16px;
							border-radius: 12px;
							backdrop-filter: blur(10px);
							font-size: 13px;
							font-weight: 500;
							z-index: 9999;
							animation: slideDown 0.4s ease, fadeOut 0.4s ease 4.6s forwards;
						}

				.custom-alert.error{
					background:rgba(255,77,79,.12);
					color:#c62828;
					border:1px solid rgba(255,77,79,.2);
				}

				.custom-alert.success{
					background:rgba(40,167,69,.12);
					color:#1b7d36;
					border:1px solid rgba(40,167,69,.2);
				}

				@keyframes slideIn{
					from{
						opacity:0;
						transform:translateX(30px);
					}
					to{
						opacity:1;
						transform:translateX(0);
					}
				}

				@media(max-width:600px){

					.card{
						padding:25px 18px;
					}

					.title{
						font-size:21px;
					}
				}

			`}</style>

			

			<div className="main-section">

				<div className="card">

					<div className="logo-section">

						<div className="logo-circle">
							<FaUserShield className="logo-icon" />
						</div>

						<div className="title">
							ASTU Admin Login
						</div>

						<div className="subtitle">
							Assam Science and Technology University
						</div>

					</div>

					{/* MOBILE */}

					<div className="input-group">

						<label className="label">
							Mobile Number
						</label>

						<input
							type="text"
							className="input"
							placeholder="Enter Mobile Number"
							maxLength={10}
							value={mobile}
							onChange={(e) =>
								setMobile(
									e.target.value.replace(/\D/g, "")
								)
							}
						/>

					</div>

					{/* SECURITY KEY */}

					<div className="input-group">

						<label className="label">
							Security Key
						</label>

						<div className="password-row">

							<input
								type={
									showKey
									? "text"
									: "password"
								}
								className="input"
								placeholder="Enter Security Key"
								value={securityKey}
								onChange={(e) =>
									setSecurityKey(
										e.target.value
									)
								}
							/>

							<button
								type="button"
								className="eye-btn"
								onClick={() =>
									setShowKey(!showKey)
								}
							>
								{showKey ? "🙈" : "👁️"}
							</button>

						</div>

					</div>

					{/* LOGIN */}

					<button
						className="login-btn"
						onClick={handleLogin}
					>
						Login
					</button>

					<div className="footer-text">
						© 2026 ASTU Admin Portal
					</div>

				</div>

				{/* ALERT */}

				{
					alertData && (

						<div
							className={`custom-alert ${
								alertData.type === "success"
								? "success"
								: "error"
							}`}
							key={alertData.id}
						>
							{alertData.message}
						</div>
					)
				}

			</div>

			
		</>
	);
}

export default Login;